import React from 'react';
import { Button, Layout, NavHeader, Icon, VisuallyHidden, Text, FlyInPanel } from '../../providers/harmony-scope/lazy-enablers';
import { isStandalone } from '../../utils/utils-standalone';
import { SettingsPanelContent } from './panel-settings';
import { smallPanelStyle } from '../../utils/common-styles';
import { useTrackInteraction } from '../../services/logging/hooks';
import { usePageContext } from '../../utils/page-context';
import { HelpAndSupportPanelContent } from './panel-help-and-support';
import { useMEMTranslation } from '../../utils/text-utils';

interface StandaloneLayoutProps {
  children: React.ReactNode;
}

export const StandaloneLayout: React.FC<StandaloneLayoutProps> = ({ children }) => {
  const { t } = useMEMTranslation();
  const showStandaloneHeader = isStandalone();
  const trackInteraction = useTrackInteraction();
  const pageName = usePageContext();
  const [isSettingsPanelOpen, setIsSettingsPanelOpen] = React.useState(false);
  const [isSupportPanelOpen, setIsSupportPanelOpen] = React.useState(false);

  const onClickSettings = () => {
    trackInteraction('Dialog Toggled', pageName, 'Standalone Header Settings');
    setIsSettingsPanelOpen(!isSettingsPanelOpen);
  };

  const onAfterHideSettings = (event: any) => {
    event.stopPropagation();
    setIsSettingsPanelOpen(false);
  };

  const onClickSupport = () => {
    trackInteraction('Dialog Toggled', pageName, 'Standalone Header Help and Support');
    setIsSupportPanelOpen(!isSupportPanelOpen);
  };

  const onAfterHideSupport = (event: any) => {
    event.stopPropagation();
    setIsSupportPanelOpen(false);
  };

  return showStandaloneHeader ? (
    <Layout>
      <NavHeader slot="header" disable-search navTitle={t('appTitle')} style={{ '--background-color': '#021838' }}>
        <Text slot="start" tag="h1" appearance="heading-4" style={{ paddingLeft: '3rem' }}>
          {t('appTitle')}
        </Text>
        <Button slot="action" appearance="stealth" onClick={onClickSupport}>
          <Icon name="telemarketer" label={t('navHeaderHelpAndSupport')} />
          <VisuallyHidden>{t('navHeaderHelpAndSupport')}</VisuallyHidden>
        </Button>
        <Button slot="action" appearance="stealth" onClick={onClickSettings}>
          <Icon name="settings" label={t('navHeaderSettings')} />
          <VisuallyHidden>{t('navHeaderSettings')}</VisuallyHidden>
        </Button>
      </NavHeader>
      <div id="main">
        {isSupportPanelOpen && (
          <FlyInPanel
            heading={t('navHeaderHelpAndSupport')}
            open={isSupportPanelOpen}
            onHeFlyInAfterHide={onAfterHideSupport}
            style={smallPanelStyle}
            slot="panel"
            contained
          >
            <HelpAndSupportPanelContent />
          </FlyInPanel>
        )}
        {isSettingsPanelOpen && (
          <FlyInPanel
            heading={t('navHeaderSettings')}
            open={isSettingsPanelOpen}
            onHeFlyInAfterHide={onAfterHideSettings}
            style={smallPanelStyle}
            slot="panel"
            contained
          >
            <SettingsPanelContent />
          </FlyInPanel>
        )}
        {children as React.ReactElement<any>}
      </div>
    </Layout>
  ) : (
    <>{children as React.ReactElement<any>}</>
  );
};
